var $ = require('jquery');
var Backbone = require('backbone');

var TemplateCache = require('TemplateCache');


var ResultView = Backbone.View.extend({

	events: {
		'click .arrow.next': 'slideImageNext',
		'click .arrow.prev': 'slideImagePrev',
		'click .reset-item': 'handleResetItem',
		'click .show-result-timetable': 'showTimeTable',
		'click .button-request': 'inquiryClicked',
	},

	initialize: function() {
		this.listenTo(this.model, "change", this.render);
	},

	render: function() {
		this.el.innerHTML = TemplateCache.render('classes-template', this.model.toJSON());

		// Sometimes the server does not return all packages
		// This hack removes them
		let hackRemoved = 0;
		$('.package-links').each(function(i, link) {
			let id = link.getAttribute("href").substring(1);
			if ( !document.getElementById(id) ) {
				$(link).remove();
				hackRemoved++;
			}
		})
		if ( hackRemoved > 0 && window.Tramino.root ) {
			console.warn(`ResultView: Removed ${hackRemoved} links to non-existant packages`);
		}
	},

	slideImageNext: function(e) {
		var $slider = $(e.target).parents('.slider');
		$slider.children(':last').insertBefore( $slider.children(':first') );
	},

	slideImagePrev: function(e) {
		var $slider = $(e.target).parents('.slider');
		$slider.children(':first').insertAfter( $slider.children(':last') );
	},

	handleBooking: function(e) {
		e.preventDefault();

		var data = window.miniEngine.app.formModel.getForm();
		data['class'] = $(e.target).data('class');

		TraminoWarenkorb.add(data).then(function() {
			// Irgendwo hin scrollen, irgendwas anzeigen...
			
		});
	},

	handleResetItem: function(e) {
		e.preventDefault();
		this.model.trigger("resetItem");
	},

	showTimeTable: function(e) {
		e.preventDefault();
		let data = $(e.currentTarget).hide().data();

		miniEngine.showResultTimeTable({
			klass: parseInt(data.klass, 10),
			container: this.$el.find(data.for),
			client: parseInt(data.client, 10),
		});
	},

	inquiryClicked: function(e) {
		e.preventDefault();

		/* Show inquiry form */
		$('.show-anfrage-button').hide();
		$('#detail-request-inner').show();

		/* Preselect class in form */
		let class_id = $(e.currentTarget).parents('.class').data('class');
		$('select[name=anfrage_class]').val(class_id);

		/* Scroll to form */
		let scrollTargets = [
			$('#detail-request'),
			$('#detail-kontakt'),
		].filter(t => t.length > 0);

		$('html, body').animate({ scrollTop: scrollTargets[0].offset().top}, 1000);
	}

});

module.exports = ResultView;



// WEBPACK FOOTER //
// /Users/bm/app/code/jsapps/modules/reserva/miniengine/views/ResultView.js